import { useState, useCallback } from 'react';
import { useCatalog } from '../hooks/useCatalog';
import { DescriptionData } from '../contexts/CatalogContext';
import { logger } from '../utils/logger';

export const useCatalogDescriptions = (catalogItemId?: string, ownerId?: string | null) => {
  const { saveDescription, getDescription, error } = useCatalog();
  const [description, setDescription] = useState<DescriptionData | null>(null);
  const [localLoading, setLocalLoading] = useState(false);

  const loadDescription = useCallback(async (id?: string) => {
    const itemId = id || catalogItemId;
    if (!itemId) return;

    setLocalLoading(true);
    try {
      const data = await getDescription(itemId, ownerId);
      setDescription(data);
      return data;
    } catch (err) {
      logger.error('Failed to load description', err);
      throw err;
    } finally {
      setLocalLoading(false);
    }
  }, [catalogItemId, getDescription, ownerId]);

  const updateDescription = useCallback(async (data: DescriptionData, id?: string) => {
    const itemId = id || catalogItemId;
    if (!itemId) throw new Error('No catalog item ID provided');

    setLocalLoading(true);
    try {
      await saveDescription(itemId, data, ownerId);
      // Don't automatically update local state to prevent overwriting user input
      // setDescription(data);
    } catch (err) {
      logger.error('Failed to save description', err);
      throw err;
    } finally {
      setLocalLoading(false);
    }
  }, [catalogItemId, saveDescription, ownerId]);

  return {
    description,
    loadDescription,
    updateDescription,
    isLoading: localLoading,
    error
  };
};
